<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="noindent">First and foremost, I would love to thank my best friend, constant supporter and the person who never fails to push me to be the best version of myself, my wife. She has read numerous drafts of this work, providing suggestions and honest advice along the way. If you enjoy this story, it is because of her, and if you do not, it is because I did not fully heed her advice. I would also like to thank everyone on the board of the Denville Historical Society for welcoming me to their family a few years back and trusting me with the research of our amazing town’s history. Thank you for the support and guidance of Vito Bianco, the man who knows so much about Denville’s history that he probably forgot more about it than I could ever dream of learning myself. I would also like to thank the people who read the early drafts of this work and provided pointers, advice, objectivity and food for thought, all of which allowed me to create the work that you now hold in your hands: Kristin Nieto, Mary Miraldi, Christopher Wagner, Maryellen Liddy, Vincent Shivas and Jess Bentley.</p>
<p class="indent">Thank you to Thomas C. Schmid, assistant prosecutor at the Morris County Prosecutor’s Office, who granted me access to the files on which a large portion of this work is based. Likewise, thank you to the late Bob Illig, who had the interest, the drive and the premonition to collect the initial newspaper clippings that began this research.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?04a35f9b